"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(updateHookState),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(initializeData),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(initializeVega),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(syncEditor),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(handleRestore),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(baseSaga);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = baseSaga;

var _effects = require("redux-saga/effects");

var _core = require("@widget-editor/core");

var _selectors = require("@widget-editor/shared/lib/modules/configuration/selectors");

var _actions = require("@widget-editor/shared/lib/modules/editor/actions");

var _actions2 = require("@widget-editor/shared/lib/modules/widget-config/actions");

var _getWidgetData = _interopRequireDefault(require("./getWidgetData"));

var _exposedHooks = require("../../exposed-hooks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var stateProxy = new _core.StateProxy();

function updateHookState() {
  var state;
  return regeneratorRuntime.wrap(function updateHookState$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)();

        case 2:
          state = _context.sent;

          if (state.widgetEditor.editor.initialized && state.widgetEditor.widgetConfig) {
            (0, _exposedHooks.localOnChangeState)(state.widgetEditor);
          }

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function initializeData(props) {
  var _ref, widgetEditor, widgetData;

  return regeneratorRuntime.wrap(function initializeData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)();

        case 2:
          _ref = _context2.sent;
          widgetEditor = _ref.widgetEditor;
          _context2.next = 6;
          return (0, _effects.call)(_getWidgetData["default"], widgetEditor);

        case 6:
          widgetData = _context2.sent;

          if (!widgetData) {
            _context2.next = 10;
            break;
          }

          _context2.next = 10;
          return (0, _effects.put)((0, _actions.setEditor)({
            widgetData: widgetData.data
          }));

        case 10:
          _context2.next = 12;
          return (0, _effects.put)((0, _actions.dataInitialized)());

        case 12:
          if (!((props === null || props === void 0 ? void 0 : props.type) === _core.constants.sagaEvents.DATA_FLOW_VISUALIZATION_READY)) {
            _context2.next = 15;
            break;
          }

          _context2.next = 15;
          return (0, _effects.call)(initializeVega);

        case 15:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function initializeVega(props) {
  var _ref2, store, editor, widgetConfig, advanced, vega, newWidgetConfig, ensureVegaProperties, _ref3, newEditorState;

  return regeneratorRuntime.wrap(function initializeVega$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)();

        case 2:
          _ref2 = _context3.sent;
          store = _ref2.widgetEditor;
          editor = store.editor, widgetConfig = store.widgetConfig;
          advanced = editor.advanced;

          if (!(!advanced && !(0, _selectors.isMap)(store))) {
            _context3.next = 13;
            break;
          }

          vega = new _core.VegaService(store);
          _context3.next = 10;
          return vega.getChart();

        case 10:
          newWidgetConfig = _context3.sent;
          _context3.next = 13;
          return (0, _effects.put)((0, _actions2.setWidgetConfig)(newWidgetConfig));

        case 13:
          if (!advanced) {
            _context3.next = 17;
            break;
          }

          ensureVegaProperties = _objectSpread({
            autosize: {
              type: "fit"
            }
          }, widgetConfig);
          _context3.next = 17;
          return (0, _effects.put)((0, _actions2.setWidgetConfig)(ensureVegaProperties));

        case 17:
          _context3.next = 19;
          return (0, _effects.select)();

        case 19:
          _ref3 = _context3.sent;
          newEditorState = _ref3.widgetEditor;
          stateProxy.update(newEditorState);

        case 22:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function syncEditor() {
  var _ref4, widgetEditor, _ref5, updatedState;

  return regeneratorRuntime.wrap(function syncEditor$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)();

        case 2:
          _ref4 = _context4.sent;
          widgetEditor = _ref4.widgetEditor;

          if (!stateProxy.ShouldUpdateData(widgetEditor)) {
            _context4.next = 7;
            break;
          }

          _context4.next = 7;
          return (0, _effects.call)(initializeData);

        case 7:
          if (!stateProxy.ShouldUpdateVega(widgetEditor)) {
            _context4.next = 10;
            break;
          }

          _context4.next = 10;
          return (0, _effects.call)(initializeVega);

        case 10:
          _context4.next = 12;
          return (0, _effects.select)();

        case 12:
          _ref5 = _context4.sent;
          updatedState = _ref5.widgetEditor;
          stateProxy.update(updatedState);
          _context4.next = 17;
          return (0, _effects.call)(updateHookState);

        case 17:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function handleRestore() {
  var _ref6, widgetEditor, editor, widget, _ref7, updatedState;

  return regeneratorRuntime.wrap(function handleRestore$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.call)(initializeData);

        case 2:
          _context5.next = 4;
          return (0, _effects.select)();

        case 4:
          _ref6 = _context5.sent;
          widgetEditor = _ref6.widgetEditor;
          editor = widgetEditor.editor;
          widget = editor.widget;

          if (widget) {
            _context5.next = 12;
            break;
          }

          stateProxy.update(widgetEditor);
          _context5.next = 12;
          return (0, _effects.cancel)();

        case 12:
          if (!(widgetEditor.configuration.visualizationType !== 'map')) {
            _context5.next = 15;
            break;
          }

          _context5.next = 15;
          return (0, _effects.call)(initializeVega);

        case 15:
          _context5.next = 17;
          return (0, _effects.select)();

        case 17:
          _ref7 = _context5.sent;
          updatedState = _ref7.widgetEditor;
          stateProxy.update(updatedState);
          _context5.next = 22;
          return (0, _effects.call)(updateHookState);

        case 22:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

function baseSaga() {
  return regeneratorRuntime.wrap(function baseSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)(_core.constants.sagaEvents.DATA_FLOW_VISUALIZATION_READY, initializeData);

        case 2:
          _context6.next = 4;
          return (0, _effects.takeLatest)(_core.constants.sagaEvents.DATA_FLOW_RESTORED, handleRestore);

        case 4:
          if (!true) {
            _context6.next = 11;
            break;
          }

          _context6.next = 7;
          return (0, _effects.take)(_core.constants.reduxActions.EDITOR_PATCH_CONFIGURATION);

        case 7:
          _context6.next = 9;
          return (0, _effects.fork)(syncEditor);

        case 9:
          _context6.next = 4;
          break;

        case 11:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}